// Français pour l'unique ligne visible du hook de sondage.
import { registerFr } from '../i18n/index.js';

registerFr({
  'data updated {time} · reconnecting': 'mise à jour {time} · reconnexion en cours',
}, 'usePoll');
